import { render, staticRenderFns } from "./SimpleCardProduct.vue?vue&type=template&id=2636e820&"
import script from "./SimpleCardProduct.vue?vue&type=script&lang=js&"
export * from "./SimpleCardProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports